module.exports = __webpack_public_path__ + "static/media/VirtualDataScientist.41d2da6c.png";